import { useContext } from "react";

import type { IBundleOptionInput } from "@jti/magento";
import { useAddProduct } from "@jti/ui/hooks/useAddProduct";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import type { ConsentValueType } from "@product-details/containers/StandardProductDetailsContainer/components/types";
import { PriceTiersContext } from "@product-details/providers/PriceTiersContext";

import AddToCartButton from "./AddToCartButton";

export type AddProductButtonProps = {
  sku: string;
  bundle: IBundleOptionInput[];
  onError: () => void;
  isLoaded: boolean;
  isDisabled?: boolean;
  customBuyCtaLabel?: string;
  onClick?: () => void;
  consentStatus?: ConsentValueType;
};

const AddProductButton = ({
  sku,
  bundle,
  onError,
  isLoaded,
  isDisabled,
  onClick,
  customBuyCtaLabel,
  consentStatus,
}: AddProductButtonProps) => {
  const { __ } = useTranslations();
  const { selectedPriceTier } = useContext(PriceTiersContext);
  const { isRunning, addProductToCart } = useAddProduct(sku, bundle, false, onError);
  const quantity = selectedPriceTier?.quantity ?? 1;
  const isLoading = isRunning || !isLoaded;

  const _onClick = () => {
    try {
      onClick?.();
      addProductToCart(quantity, undefined, consentStatus);
    } catch (error) {
      if (error instanceof Error) {
        console.error(error.message);
      }
    }
  };

  return (
    <AddToCartButton
      onClick={_onClick}
      isLoading={isLoading}
      testId="pdpAddToProduct"
      label={customBuyCtaLabel || __("product.button.addtocart")}
      isDisabled={isDisabled}
    />
  );
};

export default AddProductButton;
